import { useQuery } from "@tanstack/react-query";
import adminApiClient, { AiGreetStats } from "../../api/admin";

export const useAiGreetStats = (days: number) => {
  return useQuery<AiGreetStats>({
    queryKey: ["aiGreetStats", days],
    queryFn: () => adminApiClient.getAiGreetStats(days),
  });
};
